// eslint-disable-next-line no-unused-vars
import React from "react"
/** @jsx jsx */
import { jsx } from "theme-ui"

import Content from "../../content/about-us/nos-valeurs.json"
import { colors } from "../../utils/theme/colors"

const Paragraph = ({ text }) => (
  <p
    sx={{
      fontSize: `0.94rem`,
      color: colors.code.secondary,
      textAlign: `left`,
    }}
  >
    {text}
  </p>
)

const NosValeursTextMobile = ({ langKey }) => {
  const { paragraph1, paragraph2 } = Content[langKey]

  return (
    <>
      <div
        sx={{
          display: `flex`,
          width: `100%`,
          justifyContent: `space-between`,
          zIndex: 0,
          paddingTop: `3rem`,
        }}
      >
        <div
          sx={{
            display: `flex`,
            flexDirection: `column`,
          }}
        >
          <Paragraph text={paragraph1} />
          <Paragraph text={paragraph2} />
        </div>
      </div>
    </>
  )
}

export default NosValeursTextMobile
